













































import { Mixins, Component } from 'vue-property-decorator';
import Table from '@/components/Table/Index.vue';
import { getModule } from 'vuex-module-decorators';
import Pagination from '@/components/Pagination.vue';
import AuthModule from '@/store/modules/Auth';
import GeneralModule from '@/store/modules/General';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import PaginationMixin from '@/mixins/Pagination.vue';
import SecretPasswordModule from '@/store/modules/SecretPassword';
import ResetPasswordLogBody from '@/components/Table/ResetPasswordLogBody.vue';
import { IResetPasswordLog, IReqResetPassLog, Role } from '@/interface/ResetPasswordLog';
import moment from 'moment';
import ResetSubpassLogData from '@/data/ResetPasswordData';

@Component({
  components: {
    Table,
    Pagination,
    ResetPasswordLogBody,
  },
})
export default class ResetPasswordLog extends Mixins(ErrorHandleMixin, PaginationMixin) {
  AuthInstance = getModule(AuthModule, this.$store);

  GeneralInstance = getModule(GeneralModule, this.$store);

  SecretPasswordInstance = getModule(SecretPasswordModule, this.$store);

  TableHeadResetPassLog = ResetSubpassLogData.TableHeadPasswordLog;

  historyPage = 1;

  userData: Array<IResetPasswordLog> = [
    {
      ipAddress: '',
      user_action: {
        _id: '',
        username: '',
        role: Role.admin,
      },
      user_passive: {
        _id: '',
        username: '',
        role: Role.admin,
      },
      timestamp: '',
    },
  ];

  Criteria: IReqResetPassLog = {
    username: '',
    page: 1,
    limit: 100,
  };

  PaginationDetail = {
    current: 1,
    amount: 1,
    size: 100,
  };

  onSubmit() {
    this.findUser();
  }

  created() {
    this.onReset();
  }

  async findUser() {
    this.GeneralInstance.toggleLoading(true);

    const { data } = await this.SecretPasswordInstance.FecthResetPasswordLog(
      this.Criteria,
    );
    const resData = data.list.map((item: IResetPasswordLog) => ({
      ...item,
      timestamp: moment(item.timestamp).tz('Asia/Bangkok').format('DD/MM/YYYY, hh:mm:ss'),
    }));
    this.userData = resData;
    this.GeneralInstance.toggleLoading(false);
    this.PaginationDetail.current = 1;
    this.PaginationDetail.amount = 1;
    this.Criteria.page = 1;
  }

  changePage(i: number) {
    this.PaginationDetail.current = i;
    this.Criteria.page = i;
    this.findUser();
  }

  onReset() {
    this.initial();
  }

  initial() {
    this.userData = [];
    this.Criteria = {
      username: '',
      page: 1,
      limit: 100,
    };
  }
}
